import React, { useState, useEffect } from "react"
import { Row, Col, Input } from "reactstrap"
import MwSelect from "../../components/Common/MwSelect"
import { fmtYNA } from "../../components/Common/reportPrintShared"

const EditableColumn = (props: any) => {
  const [editable, setEditable] = useState(false)
  const [count, setCount] = useState(true)

  useEffect(() => {
    if (count) {
      setEditable(props.value ? false : true)
      setCount(false)
    }
  }, [props.value, count])

  function onKeyDown(e) {
    if (e.keyCode == 13 && props.value) {
      setEditable(false);
      props.keyPress && props.keyPress(e);
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          {!editable && (
            // Select values (yes/no/na) are shown capitalised & centred; the raw
            // stored value may carry a ":score" suffix, so strip it for display.
            <span
              onClick={e => { if (!props.disabled) setEditable(true) }}
              style={
                props.type === "select"
                  ? { display: "block", textAlign: "center" }
                  : undefined
              }
            >
              {props.type === "select"
                ? fmtYNA(String(props.value ?? "").split(":")[0])
                : props.value}
            </span>
          )}
          {editable && (
            <React.Fragment>
              {props.type == "text" || props.type == "input" || !props.type ? (
                <Input
                  type="text"
                  onKeyDown={onKeyDown}
                  onChange={e => props.update(e.target.value)}
                  value={props.value ? props.value : ""}
                  className="inner form-control"
                  disabled={props.disabled ? props.disabled : false}
                  placeholder={(props.placeholder) ? props.placeholder : "Enter here"}
                />
              ) : props.type == "select" ? (
                <MwSelect
                  value={props.value ? props.value : ""}
                  onChange={(val: any) => props.update(val)}
                  options={props.options || []}
                  placeholder="Select"
                  disabled={props.disabled ? props.disabled : false}
                />
              ) : (
                <></>
              )}
            </React.Fragment>
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default EditableColumn
